const groupPrefix = 'orders'

export const apiOrders = {
	createReservation: async (productID: number, days: number) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}`, {
			method: 'POST',
			body: orderToJSON({ productID, days }),
		})
		return Order(data)
	},

	fetchAllReservations: async () => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}`, {
			method: 'GET',
		})
		return Order(data)
	},

	fetchSingleReservation: async (orderID: string) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}/${orderID}`, {
			method: 'GET',
		})
		return Order(data)
	},
}
